export enum LinkType {
  Default = 1,
  ProjectHome = 2,
  Custom = 99,
}
